// import React from "react";
// import { Form } from "react-bootstrap";
// import { Controller } from "react-hook-form";
// import { SelectButton } from "primereact/selectbutton";

// const SelectFormat = ({
//   name,
//   label,
//   control,
//   options,
//   placeholder,
//   onChange,
//   required,
//   errors,
// }) => {
//   const transformedOptions = options?.map((option) => {
//     if (typeof option === "string") {
//       return { label: option, value: option };
//     } else {
//       return option;
//     }
//   });

//   return (
//     <Form.Group className="mb-3">
//       <Form.Label className="fw-bold pb-1">
//         {label} {required && <span className="mx-1 text-danger">*</span>}
//       </Form.Label>
//       <Controller
//         control={control}
//         name={name}
//         render={({ field }) => (
//           <SelectButton
//             {...field}
//             value={field?.value}
//             options={transformedOptions}
//             onChange={(e) => {
//               field.onChange(e.value);
//               // onChange && onChange(e);
//             }}
//             placeholder={placeholder}
//           />
//         )
//     }
//       />
//       {errors && <div className="text-danger">{errors[name]?.message}</div>}
//     </Form.Group>
//   );
// };

// export default SelectFormat;

import * as React from "react";
import { Controller } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { SelectButton } from "primereact/selectbutton";

const SelectButtonFormat = ({
  control,
  name,
  label,
  options,
  type,
  errors,
  onChange,
  placeholder,
  required
}) => {
  const handleCheckbox = (value) => {
    console.log(value);
  };
  return (
    <Form.Group className="mb-3" dir="ltr">
      {/* <Form.Label className="fw-bold pb-1" dir="rtl">
        {label}
        {required && <span className="mx-1 text-danger">*</span>}
      </Form.Label> */}
      <Controller
        name={name}
        className="fs-4 fw-bold"
        control={control}
        render={({ field }) => (
          <SelectButton
          className="btn btn-sm"
            {...field}
            value={field?.value}
            options={options}
            onChange={(e) => {
              field.onChange(e.value);
            }}
            placeholder={placeholder}
            optionLabel={"label"}
          />
        )}
      />
    </Form.Group>
  );
};

export default SelectButtonFormat;
